// extracted by mini-css-extract-plugin
module.exports = {"spacer":"content-spacer-module--spacer--1t1L7"};